export default __webpack_public_path__ + "static/media/danji_cg_01_big.353b8066.jpg";